import React from 'react';
import { OverlayUI , DeckUI } from '@seedlang/state';
import { observer } from 'mobx-react';
import Overlay from 'components/layout/overlay';
import ProfileHome from 'components/profile/profile_home';
import DeckShow from 'components/deck/deck_show';
import UserIndex from 'components/user/user_index';
import Faq from 'pages/main/faq';
import Contact from 'pages/main/contact_seedlang';
import Privacy from 'pages/main/privacy';
import Partners from 'pages/main/partners';
import DeckSettings from 'components/deck/deck_settings';
import Shortcuts from 'components/deck/shortcuts';
import MediaBlocked from 'components/card/media_blocked';
import SourceEdit from 'components/source/source_edit';
import TranslationComments from 'components/comment/translation_comments';
import TriviaResults from 'components/trivia/trivia_results';
import ReviewDetails from 'components/card/review_details';
import ReviewHistory from 'components/review/review_history';
import CardNote from 'components/card/card_note';
import { Settings } from 'components/user/settings';
import ReportBug from 'components/user/report_bug';
import DeckGrammar from 'components/deck/deck_grammar';
import ConceptDescriptionWithSentence from 'components/deck/concept_description_with_sentence';
import ConjugationTable from 'components/conjugation_table';
import GrammarTip from 'components/grammar_tip';
import VocabCard from 'components/card/vocab_card';
import ReportMeaningsScreen from 'components/vocab/report_meanings_screen';
import VocabSentencePopup from 'components/vocab/vocab_sentence_popup';
import GoToCard from 'components/deck/go_to_card';

@observer
class OverlayWrapper extends React.Component {

  constructor(props) {
    super(props);
    this.components = {
      cardNote: CardNote,
      profile: ProfileHome,
      deckShow: DeckShow,
      userIndex: UserIndex,
      faq: Faq,
      settings: Settings,
      contact: Contact,
      privacy: Privacy,
      partners: Partners,
      deckSettings: DeckSettings,
      mediaBlocked: MediaBlocked,
      shortcuts: Shortcuts,
      goToCard: GoToCard,
      sourceEdit: SourceEdit,
      cardComments: TranslationComments,
      triviaResults: TriviaResults,
      reviewDetails: ReviewDetails,
      reviewHistory: ReviewHistory,
      deckGrammar: DeckGrammar,
      conjugationTable: ConjugationTable,
      reportBug: ReportBug,
      reportMeanings: ReportMeaningsScreen,
      vocabSentencePopup: VocabSentencePopup,
      vocabCard: VocabCard,
      grammarTip: GrammarTip,
      conceptDescription: ConceptDescriptionWithSentence,
    };
  }

  render() {
    return (
      <div>
        {
          OverlayUI.overlays?.map(item => {
            return (
              <Overlay
                height={DeckUI.hasDeck && item.name !== 'deckShow' ? DeckUI.layout.deckHeight : item.props.layout.viewportHeight}
                layout={item.props.layout}
                overlayState={item.overlayState}
                key={item.props.overlayId}
                deckOverlay={DeckUI.hasDeck && item.name !== 'deckShow'}
                {...item.props}
              >
                {React.createElement(this.components[item.name],
                  {
                    ...item.props,
                    debugInfo: DeckUI.commentDebugInfo,
                    commentCreatePlaceholder: 'Leave a Public Comment',
                    inDeckComments: DeckUI.hasDeck && item.name === 'cardComments',
                  })}
              </Overlay>
            );
          })
        }
      </div>
    );
  }
}

export default OverlayWrapper;
